import {InsightMetrics, LMFSAccessor} from "@amzn/dolphin-web-framework";
import { CYCLE_CONSTANTS } from "../CycleSelector/Constants";

async function getConsentStatus(stage, region, metricType, setConsentStatus, setExperimentStatus) {
    const data = await LMFSAccessor.fetchUpdateConsentStatus(stage, region, LMFSAccessor.CONSENT_REQUEST_TYPES.FETCH,
        getConsentType(metricType), false);
    if (data && data.result) {
        setConsentStatus(data.result);
    }

    if (setExperimentStatus && data && data.experimentStatus) {
        setExperimentStatus(data.experimentStatus);
    }
}

async function updateConsentStatus(stage, region, metricType, isConsented, setConsentStatus) {
    const data = await LMFSAccessor.fetchUpdateConsentStatus(stage, region, LMFSAccessor.CONSENT_REQUEST_TYPES.UPDATE,
        getConsentType(metricType), isConsented);
    if (data && data.result) {
        setConsentStatus(data.result);
    }
}

async function getInductMetrics(stage, region, setData) {
    const data = await LMFSAccessor.fetchInductMetrics(stage, region, LMFSAccessor.METRIC_QUERY_TYPE.PROCESS);
    if (data) {
        setData(data);
    }
}

async function getAssociatesData(stage, region, cycle, setData) {
    const data = await LMFSAccessor.fetchSVSAssociatesData(stage, region, cycle || CYCLE_CONSTANTS.DEFAULT_CYCLES[0].value);
    if (data) {
        setData(data);
    }
}

function getConsentType(metricType) {
    if (metricType === InsightMetrics.INDUCT_INDUCT) {
        return LMFSAccessor.CONSENT_TYPE.INDUCT_PROCESS;
    } else if (metricType === InsightMetrics.STOW_STOW) {
        return LMFSAccessor.CONSENT_TYPE.STOW_PROCESS;
    }
    return null;
}

function getNumericalDisplayValueFromData(value) {
    if (typeof value === 'number') {
        return Math.round(value);
    }
    return 'N/A';
}

export {
    getConsentStatus,
    updateConsentStatus,
    getInductMetrics,
    getAssociatesData,
    getNumericalDisplayValueFromData
};
